<template>
  <div class="workflow-summary-cards-skeleton">
    <div class="skeleton-cards-grid">
      <div class="skeleton-card skeleton-card-up-to-date">
        <v-skeleton-loader
          type="heading"
          width="180px"
          class="skeleton-heading"
        />
        <v-skeleton-loader
          type="text"
          width="80px"
          class="skeleton-value"
        />
        <div class="skeleton-progress-track" />
      </div>
      <div
        v-for="index in metricCardCount"
        :key="index"
        class="skeleton-card"
      >
        <v-skeleton-loader
          type="heading"
          width="120px"
          class="skeleton-heading"
        />
        <v-skeleton-loader
          type="text"
          width="60px"
          class="skeleton-value"
        />
        <v-skeleton-loader
          type="text"
          width="70px"
          class="skeleton-caption"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  // Total columns: OK card plus metric cards
  columnCount: { type: Number, default: 5 },
});

const metricCardCount = computed(() => Math.max(0, props.columnCount - 1));

const gridColumnCount = computed(() => props.columnCount);
</script>

<style lang="less" scoped>
.workflow-summary-cards-skeleton {
  min-width: 0;
}

.skeleton-cards-grid {
  display: grid;
  grid-template-columns: repeat(v-bind(gridColumnCount), minmax(0, 1fr));
  gap: 24px;
  min-width: 0;
}

.skeleton-card {
  min-width: 0;
  height: 160px;
  padding: 16px;
  border-radius: 6px;
  border: 1px solid @stroke-default;
  background: @white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  .skeleton-heading {
    margin-bottom: 8px;
  }

  .skeleton-value {
    margin-bottom: 4px;
  }

  .skeleton-caption {
    margin-top: 0;
  }
}

.skeleton-card-up-to-date {
  .skeleton-progress-track {
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background: @stroke-default;
    margin-top: auto;
  }
}

:deep(.v-skeleton-loader) {
  background: transparent;
}

:deep(.v-skeleton-loader__heading),
:deep(.v-skeleton-loader__text) {
  margin: 0;
}
</style>
